const Uncapitalize = {
    created() { },
    beforeMount(el, binding, vnode) {
        const elToLower = () => {
            el.value = el.value.toLowerCase();
        };
        el.onchange = elToLower;
        el.onkeyup = elToLower;
    },
    mounted() { },
    beforeUpdate() { },
    updated() { },
    beforeUnmount(el) { },
    unmounted() { },
};
export default Uncapitalize;
